import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { AddFromListDialogData } from './add-from-list-dialog.data';

@Component({
    selector : 'add-from-list-dialog',
    template: require('./add-from-list-dialog.component.html'),
    styles: [require('./add-from-list-dialog.component.scss')]
})
export class AddFromListDialogComponent {
    public filter = '';

    constructor(@Inject(MAT_DIALOG_DATA) public data: AddFromListDialogData) {
    }

    public getName(item) {
        return item.name ? item.name : item.Name;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/add-from-list-dialog/add-from-list-dialog.component.ts